import { render, staticRenderFns } from "./AddStartupsUrl.vue?vue&type=template&id=20a04e66&scoped=true&"
import script from "./AddStartupsUrl.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartupsUrl.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a04e66",
  null
  
)

export default component.exports